import { createFileRoute } from "@tanstack/react-router";
import UnitedHealthcareInsurance, {
  config,
} from "@/pages/UnitedHealthcareInsurance";
import { buildInsuranceSchema } from "@/components/InsurancePageTemplate";
export const Route = createFileRoute("/unitedhealthcare-insurance")({
  component: RouteComponent,
  head() {
    return {
      meta: [
        {
          title: "UnitedHealthcare TMS Coverage | Neuro Wellness TMS",
        },
        {
          name: "description",
          content:
            "Have UnitedHealthcare insurance? Learn about TMS therapy, SAINT TMS, and depression treatment options that may be available through your UHC plan in Coral.",
        },
        {
          property: "og:title",
          content: "UnitedHealthcare TMS Coverage | Neuro Wellness TMS",
        },
        {
          property: "og:description",
          content:
            "Have UnitedHealthcare insurance? Learn about TMS therapy, SAINT TMS, and depression treatment options that may be available through your UHC plan in Coral.",
        },
        {
          property: "og:url",
          content: "https://neurowellnesstms.com/unitedhealthcare-insurance",
        },
        {
          property: "og:type",
          content: "website",
        },
        {
          name: "twitter:card",
          content: "summary_large_image",
        },
      ],
      links: [
        {
          rel: "canonical",
          href: "https://neurowellnesstms.com/unitedhealthcare-insurance",
        },
      ],
      scripts: [
        {
          type: "application/ld+json",
          children: JSON.stringify(buildInsuranceSchema(config)),
        },
      ],
    };
  },
});
function RouteComponent() {
  return <UnitedHealthcareInsurance />;
}
